var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.839,
    height: 26.839,
    viewBox: "0 0 26.839 26.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(-6001.439 -6775.828)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 13.419,
    cy: 13.419,
    r: 13.419,
    transform: "translate(6001.439 6775.828)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M6013.716,6791.882a5.636,5.636,0,0,1,.109-1.159,2.889,2.889,0,0,1,.471-.984l2-2.777a2.6,2.6,0,0,0,.558-1.476,2,2,0,0,0-3.357-1.454,2.434,2.434,0,0,0-.634,1.9h-2.285v-.449a4.085,4.085,0,0,1,1.28-3.05,4.159,4.159,0,0,1,2.951-1.224,4.461,4.461,0,0,1,3.007,1.137,4.1,4.1,0,0,1,1.323,3.159,3.938,3.938,0,0,1-.722,2.351l-2.033,2.8a2.289,2.289,0,0,0-.383,1.411v1.279h-2.285Zm0,3.116H6016v2.285h-2.285Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/iconQuestion.8cb0046955e23e101925407d37171219.svg";
export { ForwardRef as ReactComponent };